let hasBeenVisibleState = !("visibilityState" in document);
let hasUnloaded = false;

document.addEventListener("visibilitychange", () => {
  hasBeenVisibleState =
    hasBeenVisibleState || document.visibilityState === "visible";
});

window.addEventListener("pagehide", () => {
  hasUnloaded = true;
});

export function hasBeenVisible() {
  return hasBeenVisibleState;
}

export function isUnloading() {
  return hasUnloaded;
}
